module.exports = __webpack_public_path__ + "static/media/icon-gallery-white.ef9205fc.svg";